import React from 'react';

/**
 * Bloco de carregamento com a forma do conteúdo que vem depois.
 *
 * O visual (cor, varredura, anti-piscada) mora na classe `.skeleton` do
 * index.css — aqui só entram o tamanho, que vem por className, e o
 * `aria-hidden`: quem anuncia para o leitor de tela é o `SkeletonArea` em volta,
 * senão cada bloquinho viraria um anúncio.
 */
export default function Skeleton({ className = 'h-4 w-full' }: { className?: string }) {
  return <div aria-hidden="true" className={`skeleton ${className}`} />;
}

/**
 * Região de carregamento. Existe para o leitor de tela ouvir "carregando" uma
 * vez, em vez de nada (o que acontece hoje em todas as 28 telas com spinner).
 */
export function SkeletonArea({
  children,
  className = '',
  label = 'Carregando',
}: {
  children: React.ReactNode;
  className?: string;
  label?: string;
}) {
  return (
    <div role="status" aria-live="polite" aria-label={label} className={className}>
      {children}
    </div>
  );
}

/** Parágrafo falso. A última linha sai curta, senão o bloco parece uma tabela. */
export function SkeletonLinhas({ linhas = 3, className = '' }: { linhas?: number; className?: string }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: linhas }, (_, i) => (
        <Skeleton key={i} className={`h-3 ${i === linhas - 1 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  );
}

/** Cartão genérico: mesma moldura (raio, sombra, borda no dark) dos cards reais. */
export function SkeletonCartao({ className = '', linhas = 2 }: { className?: string; linhas?: number }) {
  return (
    <div
      className={`p-4 rounded-card bg-white dark:bg-gray-800 shadow-soft dark:shadow-none dark:border dark:border-gray-700 ${className}`}
    >
      <div className="flex items-center gap-3">
        <Skeleton className="w-10 h-10 rounded-xl flex-shrink-0" />
        <SkeletonLinhas linhas={linhas} className="flex-1" />
      </div>
    </div>
  );
}
